import storage from 'local-storage-fallback';
import { COOKIES_ACCEPTANCE_TIMESTAMP_KEY, COOKIES_REJECTION_TIMESTAMP_KEY, } from '../components/CookieBanner/CookieBanner';
import { COOKIE_STATE } from '../types/CookieState';
const THIRTY_DAYS = 1000 * 60 * 60 * 24 * 30;
export const getLatestDecision = () => {
    const decisions = [
        {
            type: COOKIE_STATE.ACCEPTED,
            value: storage.getItem(COOKIES_ACCEPTANCE_TIMESTAMP_KEY),
        },
        {
            type: COOKIE_STATE.REJECTED,
            value: storage.getItem(COOKIES_REJECTION_TIMESTAMP_KEY),
        },
    ];
    const validDecisions = decisions.filter((cookie) => {
        const parsedDate = cookie.value ? new Date(parseInt(cookie.value, 10)).getTime() : NaN;
        if (Number.isNaN(parsedDate)) {
            return false;
        }
        return parsedDate + THIRTY_DAYS >= Date.now();
    });
    if (validDecisions.length > 0) {
        return validDecisions.sort().reverse()[0].type;
    }
    return COOKIE_STATE.UNKNOWN;
};
